import React from 'react'
import { useHistory } from 'react-router-dom'

import { DialogLevel, useDialog } from "../../dialog/hook"

import LoginForm from "../../../features/auth/pages/auth/login-form"
import RegisterForm from '../../../features/auth/pages/auth/register-form'
import ForgotPasswordForm from '../../../features/auth/pages/forgot/forgot-form'

type AuthFormsResult = {
    showLoginForm: () => void
    showRegisterForm: () => void
    showForgotPasswordForm: () => void
}

export const useAuthForms = (isDialog: boolean = true, onSuccess?: (isNewUser: boolean) => void): AuthFormsResult => {
    const history = useHistory()
    const { setComponent, closeDialog } = useDialog()

    const level = DialogLevel.Top

    const onSuccessfulLogin = (isNewUser: boolean) => {
        closeDialog(level)
        console.log("Showing osSuccess", onSuccess)
        if (onSuccess) {
            onSuccess(isNewUser)
        }
    }

    const showLoginForm = () => {
        if (isDialog) {
            setComponent(<LoginForm onSuccess={() => onSuccessfulLogin(false /* TODO: actually check user */)} isDialog={true} />, undefined, level)
            return
        }

        history.push('/auth/login')
    }

    const showRegisterForm = () => {
        if (isDialog) {
            setComponent(<RegisterForm onSuccess={() => onSuccessfulLogin(true)} isDialog={true} />, undefined, level)
            return
        }

        history.push('/auth/register')
    }

    const showForgotPasswordForm = () => {
        if (isDialog) {
            setComponent(<ForgotPasswordForm onSuccess={() => onSuccessfulLogin(false)} isDialog={true} />, undefined, level)
            return
        }

        history.push('/auth/forgot-password')
    }

    return {
        showLoginForm, showRegisterForm, showForgotPasswordForm,
    }
}